import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from '../../../../store/useCommonCodeStore';
import { defaultPUR2040_R01Filter, usePUR2040_R01Store } from "./Store_PUR2040_R01";
import { SearchSpacer } from "src/components/common/common";
import { CompanyDto } from "src/dtos/company/companyDto";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { searchCustomer } from "src/apis/customerApi";

export const SearchSection_PUR2040_R01 = () => {
    const { PUR2040_R01Filter, setPUR2040_R01Filter } = usePUR2040_R01Store();
    const { compCdList } = useCommonCodeStore();
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
    const { setCodeSearchModalProps } = useUiuxStore();

	const handleCustFoucsId = 'infoCustInput_search';	
	const handleItemFoucsId = 'infoItemInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: handleCustFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: PUR2040_R01Filter.customCd || '',
				customNm: PUR2040_R01Filter.customNm || '',
			}),
		},
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: handleItemFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, '', '', '');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: PUR2040_R01Filter.itemCd || '',
				itemNm: PUR2040_R01Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PUR2040_R01Filter,
		setEditData: setPUR2040_R01Filter,
		defaultData: defaultPUR2040_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR2040_R01_search'
	});

    return (
        <div className="w-full ">
            <SearchSectionDoubleForm >
                <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={PUR2040_R01Filter.compCd}
                    optionList={compCdList}
                    onChangeValue={v => setPUR2040_R01Filter({ compCd: v === 'all' ? '' : v })}
                />
                <SearchDateRangeForm
                    label="매입기간"
                    visible={pickerVisible}
                    setVisible={setPickerVisible}
                    dateRange={PUR2040_R01Filter.dateRange}
                    setDateRange={v => setPUR2040_R01Filter({ dateRange: v })}
                    pickerPosition={pickerPosition}
                    setPickerPosition={setPickerPosition}
                />
                <SearchCodeModalForm
                    label="거래처"
                    value={PUR2040_R01Filter.customCd}
                    valueLabel={PUR2040_R01Filter.customNm}
                    handleFoucsId={handleCustFoucsId}
                    onChange={getFieldHandlers('customCd').onChange}
                    onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
                />
                <SearchCodeModalForm
                    label="품목코드"
                    value={PUR2040_R01Filter.itemCd}
                    valueLabel={PUR2040_R01Filter.itemNm}
                    handleFoucsId={handleItemFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />
            </SearchSectionDoubleForm>
        </div>
    );
};
